import { FC, useMemo, useState } from "react";

import { AddressForm, FormBuilder } from "shared/components";
import { IPlace, IFormButtons, IAddress } from "shared/types";
import { fields } from "./formData";

interface PlaceFormProps {
  isSubmitting?: boolean;
  hasError?: boolean;
  defaultValues?: Record<string, any>;
  buttons?: IFormButtons;
  resetForm?: boolean;
  handleSubmit: (place: IPlace) => void;
}

export const PlaceForm: FC<PlaceFormProps> = ({
  hasError,
  defaultValues,
  handleSubmit,
  ...rest
}) => {
  const [address, setAddress] = useState<IAddress | null>(
    defaultValues?.address
  );

  const { addressDefaultValues, titleDefaultValue } = useMemo(() => {
    const { title, address } = defaultValues || {};
    return {
      addressDefaultValues: address,
      titleDefaultValue: { title },
    };
  }, [defaultValues]);

  const preventSubmit = useMemo(() => !address, [address]);

  const submitAddress = (address: IAddress | null) => {
    setAddress(address);
  };

  const onSubmit = (place: Partial<IPlace>) => {
    if (address) {
      const data = {
        ...place,
        address,
      } as IPlace;

      handleSubmit(data);
    }
  };

  return (
    <FormBuilder
      onSubmit={onSubmit}
      fields={fields}
      defaultValues={titleDefaultValue}
      preventSubmit={preventSubmit}
      apiErrorMessage={hasError}
      {...rest}
    >
      <AddressForm
        defaultValues={addressDefaultValues}
        submitAddress={submitAddress}
      />
    </FormBuilder>
  );
};
